if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        const activeMediaIndex = [...activeMedia.parentElement.children].indexOf(activeMedia);

        function navigation(slider) {
          let wrapper, arrowLeft, arrowRight;

          function markup(remove) {
            wrapperMarkup(remove);

            arrowMarkup(remove);
          }

          function removeElement(element) {
            element.parentNode.removeChild(element);
          }

          function createDiv(className) {
            var div = document.createElement("div");
            var classNames = className.split(" ");

            classNames.forEach((name) => div.classList.add(name));

            return div;
          }

          function arrowMarkup(remove) {
            if (remove) {
              removeElement(arrowLeft);
              removeElement(arrowRight);

              return;
            }

            arrowLeft = createDiv("arrow arrow--left");
            arrowRight = createDiv("arrow arrow--right");

            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight.addEventListener("click", () => slider.next());

            wrapper.appendChild(arrowLeft);
            wrapper.appendChild(arrowRight);
          }

          function wrapperMarkup(remove) {
            if (remove) {
              var parent = wrapper.parentNode;

              while (wrapper.firstChild) {
                parent.insertBefore(wrapper.firstChild, wrapper);
              }

              removeElement(wrapper);

              return;
            }

            wrapper = createDiv("navigation-wrapper");

            slider.container.parentNode.appendChild(wrapper);

            wrapper.appendChild(slider.container);
          }

          slider.on("created", () => {
            markup();
          });

          slider.on("optionsChanged", () => {
            markup(true);
            markup();
          });

          slider.on("destroyed", () => {
            markup(true);
          });
        }

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        ) {
          activeMedia.loadContent();
        }

        var slider = new KeenSlider(
          ".product-media-modal__content",
          {
            loop: true,
            slidesPerView: 1,
            created: () => {
              console.log("created");
            },
          },
          [navigation]
        );

        slider.moveToIdx(activeMediaIndex);
      }
    }
  );
}
